import { Box, Button, Stack, Typography } from "@mui/material";

import { useZendeskTickets } from "../../Pages/Home/NewHome/hooks";
import { useAvaDialogContext } from "./AvaDialogContextProvider";
import { DoitLoading } from "./DoitLoading";
import { RecentTicketRow } from "./RecentTicketRow";

export const RecentTickets = ({ showHeader = true }: { showHeader?: boolean }) => {
  const { tickets, loading } = useZendeskTickets();

  const { handleCloseAvaDialog } = useAvaDialogContext();

  const ticketsToShow = tickets.slice(0, 2);

  return (
    <Box>
      {showHeader && (
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="subtitle1" fontWeight={500} data-cy="recent-tickets-header">
            Recent Tickets
          </Typography>
          <Button variant="text" color="primary" onClick={handleCloseAvaDialog} data-cy="view-all-tickets-button">
            View all tickets
          </Button>
        </Stack>
      )}
      {loading ? (
        <DoitLoading />
      ) : (
        ticketsToShow.map((ticket) => <RecentTicketRow key={ticket.ref.id} ticket={ticket} />)
      )}
    </Box>
  );
};
